<template>
  <div>
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 style="max-width: 800px"> Share your Sequences with your company</h1>
      </template>
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 50px 20px 20px 20px' : 'padding: 50px 20px 30px 20px;'}`">
        A company needs standards. In the TAKT.app we already deliver the standards. WORK.packages and WORK.sequences are ready to share with my company in our PRO.account.
        </p>
      </template>
    </HomeDetailInfoSiteOne>
  </div>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>
